<template>
    <div>
        <el-dialog :title="dialogType == 'realnaem' ? '实名认证' : '授权收款账户'" :visible.sync="isShow"
            :width="dialogType == 'realnaem' ? '420px' : '460px'" class="" @close="closeDialog">
            <div class="" v-if="dialogType == 'realnaem'">
                <div class="y-t-ac y-mb-20"><i class="tip-icon-big  el-icon-warning"></i></div>

                <div class="tip-isRealNameNo">仅支持使用实名认证通过的用户支付宝充值，请先认证！</div>


            </div>
            <div class="" v-else>

                <div class="tip-isRealNameNo">账户验证成功，请去授权支付宝账户</div>


            </div>
            <span slot="footer" class="border-top special-title-flag  dialog-footer" v-if="dialogType == 'realnaem'">
                <el-button @click="isShow = false">取 消</el-button>
                <el-button type="primary" @click="goToIsRealName">去认证</el-button>
            </span>
            <span slot="footer" class="border-top special-title-flag  dialog-footer" v-else>
                <el-button type="primary" @click="toAlipay">去授权支付宝账户</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>


export default {
    name: 'isRealNameNo',
    components: {},
    props: {
        withdrawMoney:{
            type: String,
            default: ''
        },
        requiredAliAuthCode: {
            type: String,
            default: ''
        },
        dialogType: {
            type: String,
            default: 'realnaem'
        },
        visible: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {

            isShow: this.visible,
        }
    },
    watch: {
        visible(val) {
            this.isShow = val;
        }
    },
    computed: {
    },
    mounted() {
        console.log("sss",this.withdrawMoney)
    },
    methods: {
        toAlipay() {
            // let apiOrigin = window.location.origin;
            this.$emit('timekeeping', new Date().getTime());
            let apiOrigin = 'https://kh.yto.net.cn';
            // let apiOrigin = 'https://kh-test.yto56test.com';//uat
            window.open('https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021002174632096&scope=auth_base&redirect_uri=' + apiOrigin + '/specialDeliveryOffer/specialOrderIndex/accountIndex&state=' + this.requiredAliAuthCode+'-'+this.withdrawMoney+'&auth_type=1', '_self');
            this.close();
        },
        goToIsRealName() {
            this.isShow = false;
            this.$emit('update:visible', false);
            this.$emit('goToIsRealName');
        },
        closeDialog() {
            this.$emit('update:visible', false);
            this.isShow = false;
        }
    }
}
</script>
<style lang="scss" scope>
.tip-icon-big {
    color: #FAAD14;
    font-size: 48px;
}

.tip-isRealNameNo {
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    text-align: center;
    padding: 0 90px;
}
</style>